import styled from "styled-components"
import { device } from "breakpoints"
import { SelectInput } from "components/SelectInput"

export const NewsFilterSelect = styled(SelectInput)``
export const LandingText = styled.div`
  background: rgba(42, 52, 73, 0.95);
  border-radius: 2px;
  width: 100%;
  margin-top: -90px;
  z-index: 2;
  display: flex;
  flex-direction: column;
  padding: 22px 25px;
  margin-bottom: 30px;
  z-index: 2;
  @media ${device.tablet} {
    margin-top: -110px;
    padding: 34px 30px;
  }

  @media ${device.desktop} {
    flex-direction: row;
    align-items: center;
    margin-top: -200px;
    padding: 60px 45px;
    margin-bottom: 40px;
  }

  @media ${device.large} {
    padding: 73px 60px;
    margin-top: -200px;
  }

  h1 {
    font-size: 30px;
    color: white;
    font-weight: 300;
    line-height: 100%;
    margin-bottom: 12px;
    @media ${device.desktop} {
      font-size: 42px;
      flex-shrink: 0;
      width: calc(41.66666667% - 20px);
      margin: 0;
    }

    @media ${device.large} {
      font-size: 48px;
    }
  }

  p {
    font-size: 16px;
    color: white;

    @media ${device.desktop} {
      font-size: 18px;
      width: calc(58.33333333% - 20px);
      margin-left: auto;
    }

    @media ${device.large} {
      font-size: 20px;
    }
  }
`

export const ArticleDetails = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 20px;
  padding-bottom: 26px;
  border-bottom: 1px solid #dce0e7;
  width: 100%;
  @media ${device.tablet} {
    flex-direction: row;
    margin: 0 auto;
    padding-bottom: 30px;
    align-items: center;
    margin-top: 40px;
    margin-bottom: 20px;
  }

  @media ${device.desktop} {
    width: 759px;
  }

  span.category {
    height: 28px;
    background: #f17071;
    border-radius: 16px;
    font-size: 10px;
    text-transform: uppercase;
    font-weight: bold;
    color: #ffffff;
    text-align: center;
    display: inline-flex;
    padding: 0 10px;
    align-items: center;
    margin-bottom: 10px;
    transition: 100ms;

    @media ${device.tablet} {
      height: 32px;
      margin-bottom: 0;
      font-size: 12px;
      margin-right: 18px;
      letter-spacing: 0.5px;
      padding: 0 15px;
    }

    a {
      color: white;
    }

    :hover {
      background: #e56667;
    }
  }

  div {
    font-size: 12px;

    @media ${device.tablet} {
      font-size: 14px;
    }

    span.author {
      margin-right: 5px;
      text-transform: capitalize;
      @media ${device.tablet} {
        margin-right: 7px;
      }
    }
    span.reading {
      margin-left: 5px;
      text-transform: none !important;
      @media ${device.tablet} {
        margin-left: 7px;
      }
    }

    span.date {
      margin-right: 5px;
      margin-left: 5px;
      @media ${device.tablet} {
        margin-left: 7px;
        margin-right: 7px;
      }
    }
  }
`
